import React from 'react'
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Autocomplete } from '@material-ui/lab';
import { TextValidator } from 'react-material-ui-form-validator';
import { useEffect } from 'react';

export const SelectorCuentas = ({ valuesCuenta, setearIdCuenta, idCuenta, label, validators}) => {
  const { planesCuentas } = useSelector((state) => state.contratacionesCartilla);
  const [buscador, setBuscador] = useState('')
  const [planCuenta, setPlanCuenta] = useState(planesCuentas.find(cuenta => 
    idCuenta ?
      cuenta.id === valuesCuenta.idPlanCuenta :
      cuenta.id === valuesCuenta.idPlanCuentaCP 
  ))

  const optionLabel = {
    text: option => `${option?.cuenta}.${option?.subCuenta} - ${option?.descripcion}`,
    sinPunto: option => `${option?.cuenta}${option?.subCuenta} - ${option?.descripcion}`,
    regExp: new RegExp(/\./g)
  }

  const handleChangeIdCuenta = (newValue) => {
    setBuscador(newValue)
    setPlanCuenta(newValue)
    if(idCuenta){
      setearIdCuenta(
        'idPlanCuenta', newValue?.id, 
        'desCuenta', newValue?.descripcion
      )
    }else{
      setearIdCuenta(
        'idPlanCuentaCP', newValue?.id, 
        'desCuentaCP', newValue?.descripcion
      )  
    }
  }
  
  useEffect(() => {
    setBuscador(`${planCuenta?.cuenta}.${planCuenta?.subCuenta} - ${planCuenta?.descripcion}`)
  }, [setBuscador])
  
  return ( 
    <>
      <Autocomplete
        value={planCuenta}
        onChange={(e, newValue) => handleChangeIdCuenta(newValue)}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        autoHighlight
        id="free-solo-with-text-demo"
        options={planesCuentas}
        getOptionLabel={(option) => (
          optionLabel?.regExp.test(optionLabel?.text(option)) ? 
            optionLabel?.text(option) :
            optionLabel?.sinPunto(option) 
        )}
        renderOption={(option) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>{optionLabel.text(option)}</span>
          </div>
        )}
        renderInput={(params) => (
          <TextValidator 
            {...params} 
            label={label}
            value={buscador}
            validators={validators ? ["required"] : false}
            errorMessages={["La cuenta es requerida"]}
            margin='normal'
            variant="outlined"
            fullWidth
          />
        )}
      />
    </>
  )
}
